import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const dovizKuru = z.object({
    id: z.string(),
    kaynak: paraBirimi,
    hedef: paraBirimi,
    kur: z.string(),
    tarih: z.string().datetime(),
    saglayici: z.string(),
    olusturmaTarihi: z.string().datetime(),
});
export const dovizKuruOlusturIstegi = z
    .object({
    kaynak: paraBirimi,
    hedef: paraBirimi,
    kur: z.string().regex(/^\d+(\.\d{1,8})?$/, 'Geçerli kur girin'),
    tarih: z.string().datetime(),
    saglayici: z.string().trim().min(2).max(50).default('manuel'),
})
    .refine((d) => d.kaynak !== d.hedef, {
    message: 'Kaynak ve hedef aynı olamaz',
    path: ['hedef'],
});
export const dovizKuruSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(500).default(100),
    kaynak: paraBirimi.optional(),
    hedef: paraBirimi.optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
//# sourceMappingURL=doviz-kuru.js.map